export const isValuesFromArrayInArray = (array, valuesArray) => valuesArray.some((val) => array.includes(val));
